<template>
  <div class="process">
    <a-steps :current="current" :status="stepStatus">
      <a-step v-for="(item, index) in steps" :key="index" :title="item.title">
        <template slot="description">
          <div
            style="fontSize: 12px; color: rgba(0, 0, 0, 0.45); position: relative;text-align: left;"
          >
            <div class="process-name">
              {{ item.description.username }}
              <template v-if="item.description.status">
                <a-tag :color="item.description.status.color">
                  {{ item.description.status.label }}
                </a-tag>
              </template>
            </div>
            <div>{{ item.description.approveDate }}</div>
          </div>
        </template>
      </a-step>
    </a-steps>
  </div>
</template>

<script>
export default {
  name: 'process',
  data() {
    return {
      statusList: [
        { label: '待审批', color: 'blue' },
        { label: '通过', color: 'green' },
        { label: '不通过', color: 'red' },
        { label: '已撤销', color: 'gray' },
        {},
        { label: '待归档', color: 'green' },
      ],
      stepStatus: 'process',
      status: '',
    }
  },
  props: ['processList'],
  created() {
    const { status } = this.$route.query
    const { id } = this.$route.params
    if (id) {
      this.status = status
    }
  },
  computed: {
    steps() {
      const processList = this.processList
      let crtStatus = ''
      return processList.map((item, index) => {
        let description = {}
        const assigners = item.assigners

        if (assigners && assigners.length) {
          const assigner = assigners[0]
          description.approveDate = assigner.approveDate || ''
          description.username = assigner.username || ''
          description.status =
            index === 0 ? '' : this.statusList[item.status] || ''
          if (item.status === 2) {
            // 有审批未通过的
            crtStatus = 'error'
            this.stepStatus = 'error'
          }
        } else if (crtStatus !== 'error') {
          // 已撤销
          this.stepStatus = 'wait'
          if (this.status == 4)
            description.status = this.statusList[this.status - 1] || ''
        }

        if (index === processList.length - 1 && crtStatus !== 'error') {
          // 通过最后一项判断当前处于什么状态
          if (item.status === 1) {
            this.stepStatus = 'finish'
          } else if (!item.assigners.length) {
            this.stepStatus = 'wait'
          } else {
            this.stepStatus = 'process'
          }
        }
        return { title: item.taskName, description }
      })
    },
    current() {
      const processList = this.processList
      let index = -1
      index =
        processList &&
        processList.findIndex(process => {
          return process.status === 2 || process.status === 0
        })
      index = index === -1 ? (index = processList.length - 1) : index
      return index
    },
  },
}
</script>

<style scoped lang="less">
.process-name,
.process-status {
  margin: 4px 0 4px;
}
</style>
